import { render, staticRenderFns } from "./MemberStatistic.vue?vue&type=template&id=01a71822&"
import script from "./MemberStatistic.vue?vue&type=script&lang=js&"
export * from "./MemberStatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports